export enum OccupationDominanteRiveDroite {
    Inconnue = 0,
    Feuillus = 1,
    Resineux = 2,
    ZoneHumide = 3,
    Friche = 4,
    Prairie = 5,
    Culture = 6,
    EspaceVertJardin = 7,
    Canal = 8,
    GravierePlanDeau = 9,
    Urbanise = 10,
    Autre = 11,
}
